import React, { useState } from 'react';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import { IoLogoBehance } from "react-icons/io5";
import { IoLogoBuffer, IoLogoPolymer, IoLogoVk } from "react-icons/io";
import { NavLink } from 'react-router-dom';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import BrandLogo from '../../asstes/logo.jpg'
import pdf from '../../asstes/gAINE_aPEX_USDt_Final_30_05_2024.pdf'
const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenPDF = () => {
    window.open(pdf, '_blank');
  };

  const handleNav = () => {
    setNav(!nav);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const countryList = [
    { icons: <IoLogoBuffer size={25} />, countryName: "Itali" },
    { icons: <IoLogoBehance size={25} />, countryName: "India" },
    { icons: <IoLogoPolymer size={25} />, countryName: "Usa" },
    { icons: <IoLogoVk size={25} />, countryName: "Rusia" },
    { icons: <IoLogoBuffer size={25} />, countryName: "Bangladesh" },
    { icons: <IoLogoPolymer size={25} />, countryName: "Pakisthan" },
    { icons: <IoLogoBehance size={25} />, countryName: "America" },
    { icons: <IoLogoBuffer size={25} />, countryName: "Chaina" }
  ]

  return (
    <>
      <div className='nav_bar_background shadow-xl fixed top-0 z-10 w-full flex justify-between items-center h-18  mx-auto px-4 text-white'>
        {/* Desktop Navigation */}
        <div className=' w-full flex md:justify-around justify-between items-center'>
          <div className='flex justify-around gap-6 items-center'>
            <NavLink to="/home">
              <h3 className='text-white text-xl font-bold rounded-[60px]'  >
                <img src={BrandLogo} width={"135px"} className='rounded-[6px]'></img>

              </h3>
            </NavLink>
            <p className='md:flex hidden text-white font-bold' onClick={handleOpenPDF}>Documentation</p>
          </div>
          <div className='md:flex hidden z-20'>
            <div className=' '>
              <div className="p-10">
                {/* <div className="dropdown inline-block relative">
                  <button className="bg-gray-300  text-gray-700 font-semibold py-2 px-4 rounded inline-flex items-center" onClick={toggleDropdown}>
                    <span className=" flex gap-2 mr-8"><span><IoLogoBuffer size={25} /></span> English</span>
                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                  </button>
                  {isOpen && (
                    <ul className="dropdown-menu absolute text-gray-700 pt-1">
                      {
                        countryList.map((item, index) => (
                          <li key={index} className='flex cursor-pointer text-gray-400 items-center gap-5  bg-[#333]
                          hover:bg-gray-500 hover:text-slate-50 rounded-md  my-2 py-2 px-4  whitespace-no-wrap'> <span className='text-white'>{item.icons}</span><p className="">{item.countryName}</p>
                            <hr />
                          </li>
                        ))
                      }
                    </ul>
                  )}
                </div> */}
              </div>
            </div>
          </div>
          <div className=' justify-around gap-8 items-center hidden md:flex'>
            {/* <NavLink to="/" className={({ isActive, isPending }) =>
              isPending ? "pending" : isActive ? "bg-[white] text-black rounded-[20px]  " : "pendingg"
            }
            >
              <button className='font-bold  rounded-[20px] py-2 px-4'>Login</button>
            </NavLink> */}
            {/* <NavLink to="fetch-user" className={({ isActive, isPending }) =>
              isPending ? "pending" : isActive ? "bg-[white] text-black  rounded-[20px]  " : "pendingg"
            }
            >
              <button className='font-bold  rounded-[20px] py-2 px-4'>User</button>
            </NavLink> */}
            <NavLink to="register"
              // className={({ isActive, isPending }) =>
              //   isPending ? "pending" : isActive ? "bg-[white] text-black 0 rounded-[10px]  " : "pendingg"
              // }
              className="bg-[white] text-black 0 rounded-[10px]"
            >
              <button className='font-bold  rounded-[10px] py-2 px-4'>Register</button>
            </NavLink>
            <NavLink to="dashboard"
              className={({ isActive, isPending }) =>
                isPending ? "pending" : isActive ? "bg-[white] text-black rounded-[10px]  " : "pendingg"
              }
            >
              <button className='font-bold  rounded-[10px] py-2 px-4'>DashBoard</button>
            </NavLink>
          </div>
          <ConnectButton color="red" />
        </div>
        {/* Mobile Navigation Icon */}
        <div onClick={handleNav} className='block md:hidden'>
          {nav ? "" : <AiOutlineMenu size={25} />}
        </div>

        {/* Mobile Navigation Menu */}
        <ul
          className={
            nav
              ? 'fixed md:hidden left-0 top-0 w-[100%] h-full  bg-[#000300] ease-in-out duration-500'
              : 'ease-in-out w-[100%] duration-500 fixed top-0 bottom-0 left-[-100%]'
          }
        >
          {/* Mobile Logo */}
          <div className='flex justify-between'>
            <h1 className='w-full text-3xl font-bold text-[#fff] m-4'>Thinker</h1>
            <div onClick={handleNav} className='block md:hidden my-8 px-4 cursor-default'>
              {nav ? <AiOutlineClose size={25} /> : ""}
            </div>
          </div>


          {/* Mobile Navigation Items */}
          <div className=' flex-col flex px-10 w-full mx-auto my-10'>
            <NavLink onClick={handleNav} to="/"
            >
              <button className='font-bold  rounded-[20px] py-2 px-4'>Login</button>
            </NavLink>
            <NavLink onClick={handleNav} to="fetch-user"

            >
              <button className='font-bold  rounded-[20px] py-2 px-4'>User</button>
            </NavLink>
            <NavLink onClick={handleNav} to="register"

            >
              <button className='font-bold  rounded-[20px] py-2 px-4'>Register</button>
            </NavLink>
            <NavLink onClick={handleNav} to="dashboard"

            >
              <button className='font-bold  rounded-[20px] py-2 px-4'>DashBoard</button>
            </NavLink>
            <button className='font-bold  rounded-lg py-3 px-4'><ConnectButton /></button>
          </div>
        </ul>
      </div>
    </>
  );
};

export default Navbar;